module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyBmb3IgeW91IGNsYWltIG93bmVyc2hpcCBvZiB0aGUgaW5zdGFuY2UgeW91IGFyZSBnaXZlbi4KCiZuYnNwOwpUaGluZ3MgdGhhdCBtaWdodCBoZWxwCiogTG9vayBpbnRvIFNvbGlkaXR5J3MgZG9jdW1lbnRhdGlvbiBvbiB0aGUgYGRlbGVnYXRlY2FsbGAgbG93IGxldmVsIGZ1bmN0aW9uLCBob3cgaXQgd29ya3MsIGhvdyBpdCBjYW4gYmUgdXNlZCB0byBkZWxlZ2F0ZSBvcGVyYXRpb25zIHRvIG9uLWNoYWluIGxpYnJhcmllcywgYW5kIHdoYXQgaW1wbGljYXRpb25zIGl0IGhhcyBvbiBleGVjdXRpb24gc2NvcGUuCiogRmFsbGJhY2sgbWV0aG9kcwoqIE1ldGhvZCBpZHMK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/delegate.md
// module id = 1361
// module chunks = 0